import { gql } from '@apollo/client';

export const REGISTER = gql`
  mutation RegisterV2($input: RegisterInput!) {
    register(input: $input) {
      user {
        id
        uuid
        phone
      }
      verification {
        success
        verification_id
        call_number
      }
    }
  }
`;

export const START_VERIFICATION = gql`
  mutation StartVerificationV2($input: StartVerificationInput!) {
    startVerification(input: $input) {
      call_number
      success
      verification_id
    }
  }
`;

export const SEND_EXTEND_CONFIRM_CODE = gql`
  mutation SendExtendConfirmationCode($input: SendConfirmationCodeInput!) {
    sendExtendConfirmationCode(input: $input)
  }
`;

export const VERIFY_CLIENT = gql`
  mutation VerifyUserV2($input: VerifyUserInput!) {
    verifyUser(input: $input) {
      id
      uuid
    }
  }
`;

export const GET_VERIFICATION_STATUS = gql`
  query GetVerificationStatusV2($verification_id: String!) {
    getVerificationStatus(verification_id: $verification_id) {
      status
    }
  }
`;
